import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'

import styles from './tabs.scss'

class Tabs extends PureComponent {
	constructor() {
		super()

		this.state = {
			selectedTab: null,
		}
		this.handleSelect = this.handleSelect.bind(this)
	}

	handleSelect(tab) {
		this.setState({
			selectedTab: tab,
		})
	}

	transformChildren(children, { handleSelect, selectedTab, firstLinkFound }) {
		if (typeof children !== 'object') {
			return children
		}

		return React.Children.map(children, child => {
			if (!child) {
				return child
			}
			if (child.props && child.props.to) {
				const { activeClassStyle, name } = this.props
				const firstLink = !firstLinkFound

				firstLinkFound = true

				return React.cloneElement(child, {
					handleSelect,
					isActive: child.props.to === selectedTab,
					activeClass: activeClassStyle,
					namespace: name,
					firstLink,
				})
			}

			if (child.props && child.props.for) {
				return React.cloneElement(child, {
					isVisible: child.props.for === selectedTab,
				})
			}

			return React.cloneElement(
				child, {},
				this.transformChildren(child.props && child.props.children, {
					handleSelect,
					selectedTab,
					firstLinkFound,
				})
			)
		})
	}

	render() {
		const handleSelect = this.props.handleSelect || this.handleSelect
		const selectedTab = this.props.selectedTab || this.state.selectedTab

		const children = this.transformChildren(this.props.children, {
			handleSelect,
			selectedTab,
		})

		return (
			<div styleName='tab-container'>
				{children}
			</div>
		)
	}
}

Tabs.propTypes = {
	name: PropTypes.string,
	handleSelect: PropTypes.func,
	selectedTab: PropTypes.string,
	activeClassStyle: PropTypes.string,
	children: PropTypes.node,
}



export default CSSModules(Tabs, styles, {allowMultiple: true})
